const useWebSocketService = () => {
  const reset = () => {
    if (window.ws) {
      window.ws.onmessage = null;
    }
  };

  const get = async (message: any) => {
    if (!window.ws) {
      console.error('No ws connection!')
    }

    return new Promise((resolve) => {
      // Create an event handler for this specific request.
      const handler = (event: MessageEvent) => {
        resolve(JSON.parse(event.data));
        // Remove this handler so it doesn't fire for future messages.
        window.ws.removeEventListener("message", handler);
      };
    
      // Attach the new handler.
      window.ws.addEventListener("message", handler);
    
      // Send the request.
      window.ws.send(message);
    });
    
  };

  return { reset, get };
};

export default useWebSocketService;
